export { default as LtiToolRegistration } from './component/LtiToolRegistration';
export const LtiToolRegistrationDynamic = () => import('./component/LtiToolRegistration');

export { GradeSyncSettings } from './component/GradeSyncSettings';
export const GradeSyncSettingsDynamic = () => import('./component/GradeSyncSettings/GradeSyncSettings');

export { default as useGetPlatformData } from './hooks/useGetPlatformData';
